import React from 'react'
import { Route, Navigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import { isLoggedIn } from '../utils'

const PrivateRoute = ({ children, ...rest }) =>
  isLoggedIn() ? children : <Navigate to="/auth/login" />

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired
}

export default PrivateRoute
